import { TypedUseSelectorHook, useSelector } from 'react-redux'

import { StoreData } from '../reducers/typings'

export const useAppSelector: TypedUseSelectorHook<StoreData> = useSelector
